import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NglInternalOutletModule } from '../util/outlet.module';
import { NglFormElement } from './elements/element';
import { NglFormElementCheckbox } from './elements/checkbox';
import { NglFormElementCheckboxToggle } from './elements/checkbox-toggle';
import { NglFormElementCheckboxAdd } from './elements/checkbox-add';
import { NglFormInput, NglFormTextarea, NglFormSelect, NglFormCheckbox, NglFormRadio } from './elements/input';
import { NglFormElementRequired } from './elements/required';
import { NglFormGroup } from './groups/group';
import { NglFormGroupAlternate } from './groups/group-alt';
import { NglFormGroupElement } from './groups/element';
import { NglFormLabelTemplate } from './form-label';
var NGL_FORM_DIRECTIVES = [
    NglFormElement, NglFormElementCheckbox, NglFormElementCheckboxToggle, NglFormElementCheckboxAdd,
    NglFormInput, NglFormTextarea, NglFormSelect, NglFormCheckbox, NglFormRadio,
    NglFormElementRequired,
    NglFormGroup,
    NglFormGroupAlternate,
    NglFormGroupElement,
    NglFormLabelTemplate,
];
var NglFormsModule = (function () {
    function NglFormsModule() {
    }
    NglFormsModule.decorators = [
        { type: NgModule, args: [{
                    declarations: NGL_FORM_DIRECTIVES,
                    exports: NGL_FORM_DIRECTIVES,
                    imports: [CommonModule, NglInternalOutletModule],
                },] },
    ];
    /** @nocollapse */
    NglFormsModule.ctorParameters = function () { return []; };
    return NglFormsModule;
}());
export { NglFormsModule };
//# sourceMappingURL=module.js.map